import React, { FC } from 'react'
import BarGraphBase from './BarGraphBase'
import Scale from '../Scale'
import Appropriate from '../Appropriate'

interface Props {
  target: string
  value: {
    current: number,
    past: number,
    team?: number,
    occupation?: number,
    company: number,
    qasee?: number,
  }
}

const WeeklyBarGraph: FC<Props> = (props) => {
  const {
    target,
    value,
  } = props

  return (
    <>
      <div className="ruler_area">
        <div className="title" />
        <Appropriate />
      </div>
      <div className="bar_area">
        <div className="item">
          <div className="title">
            今週
            <span className="point">
              {value.current === null ? "-" : value.current }
            </span>
          </div>
          <BarGraphBase
            value={value.current || 0}
          />
        </div>
        <div className="item">
          <div
            style={{
              width: "200px",
            }}
          />
          <div
            style={{
              width: "100%",
              height: "20px",
              color: "#898989",
              paddingTop: "4px",
            }}
          >
            <Scale />
          </div>
        </div>
        <div className="item">
          <div className="title">
            先週
            <span className="point">
              {value.past === null ? "-" : value.past }
            </span>
          </div>
          <BarGraphBase
            value={value.past || 0}
          />
        </div>
        {
          target === "team" ? (
            <>
              <div className="item">
                <div className="title">
                  会社平均
                  <span className="point">
                    {value.company === null ? "-" : value.company }
                  </span>
                </div>
                <BarGraphBase
                  value={value.company || 0}
                />
              </div>
              <div className="item">
                <div className="title">
                  Qasee平均
                  <span className="point">
                    {value.qasee === null ? "-" : value.qasee }
                  </span>
                </div>
                <BarGraphBase
                  value={value.qasee || 0}
                />
              </div>
            </>
          ) : (
            <>
              <div className="item">
                <div className="title">
                  チーム平均
                  <span className="point">
                    {value.team === null ? "-" : value.team }
                  </span>
                </div>
                <BarGraphBase
                  value={value.team || 0}
                />
              </div>
              <div className="item">
                <div className="title">
                  会社平均
                  <span className="point">
                    {value.company === null ? "-" : value.company }
                  </span>
                </div>
                <BarGraphBase
                  value={value.company || 0}
                />
              </div>
              <div className="item">
                <div className="title">
                  職種平均
                  <span className="point">
                    {value.occupation === null ? "-" : value.occupation }
                  </span>
                </div>
                <BarGraphBase
                  value={value.occupation || 0}
                />
              </div>
            </>
          )
        }
      </div>
    </>
  )
}

export default WeeklyBarGraph
